import React from "react";
import ErrorPage from "./ErrorPage";

interface Error403PageProps {}

const Error403Page: React.FC<Error403PageProps> = () => {
  const errorObj = {
    title: "Access Denied!",
    description:
      "You do not have permission to access this application. We apologize for the inconvenience. If you believe that you have received this message in error, please contact IT Support",
    iconType: "lock",
  };

  return <ErrorPage {...errorObj} />;
};

export default Error403Page;
